module.exports = __webpack_public_path__ + "static/media/5import-10.68db3006.xlsx";